<template>
  <div>
    <div class="col-md-12 col-sm-12 col-lg-8 p-0">
      <pc-product-accordion :title="specification" sectionId="#specificationsPDP" />
      <div class="collapse" id="specificationsPDP">
        <div class="pt-2"></div>
        <div class="wf-product-specification-groups">
          <div class="wf-product-specification-group">
            <div class="wf-product-specification-subgroup">
              <dl class="description text-uppercase">
                <div v-if="selectedColor.colorNumber">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.product.swatch"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ selectedColor.colorName }}
                    {{ selectedColor.colorNumber }}
                  </dd>
                </div>
                <div v-if="selectedProduct && selectedProduct.sellingStyleNumber">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.product.style"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ productData.sellingStyleName }}
                    {{ selectedProduct.sellingStyleNumber }}
                  </dd>
                </div>
                <div v-if="productData.collection">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.product.collection"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    <a class="collection-code" :href="'/product-collection/' + productData.collectionCode.code
                      ">
                      {{ productData.collection }}
                    </a>
                  </dd>
                </div>
                <div v-if="productData.inventorySubType && productData.productTypeDesc.toLowerCase() != $resourceString['productCategory.ResinousFlooring'].toLowerCase()">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.product.category"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ productData.inventorySubType }}
                  </dd>
                </div>
                <div v-if="productData.inventoryType">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.product.type"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ productData.inventoryType }}
                  </dd>
                </div>
                <div v-if="productData.suggestedAdhesives.length > 0">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.recommended.adhesive"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd class="suggested-adhesives">
                    {{
                      productData.suggestedAdhesives
                        .map(c => c.styleName)
                        .filter(name => name)
                        .join(", ")
                    }}
                  </dd>
                </div>
                <div v-if="productData.construction">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.construction"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ productData.construction }}
                  </dd>
                </div>
                <div v-if="productData.testResults.tarrClassification">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.wear.rating"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ productData.testResults.tarrClassification }}
                  </dd>
                </div>
                <div v-if="productData.dyeMethod">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.dye.method"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ productData.dyeMethod }}
                  </dd>
                </div>
                <div v-if="productData.fiber">
                  <dt>
                    <div>
                      {{
                        $resourceString["product.details.specifications.fiber"]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ productData.fiber }}
                  </dd>
                </div>
              </dl>
              <div v-if="selectedProduct && selectedProduct.pdmsLink">
                <a :href="selectedProduct.pdmsLink"
                  class="btn btn-light border-grey spec-pdf-download spec-pdf-download-button mb-4 font-weight-bold">
                  <span class="png-icon png-icon-icons-glyph--k-btn-download mr-3"></span>
                  {{
                    $resourceString[
                    "product.details.specifications.download.specs"
                    ]
                  }}
                </a>
              </div>
            </div>
          </div>
          <div class="wf-product-specification-group">
            <div class="wf-product-specification-subgroup" v-if="productData.productTypeDesc.toLowerCase() != $resourceString['productCategory.ResinousFlooring'].toLowerCase()">
              <h3 class="label mb-2 font-weight-bold">
                {{ $resourceString["product.Details.ProductDimensions.Title"] }}
              </h3>
              <dl class="description text-uppercase">
                <div v-if="selectedProduct && selectedProduct.productSizeImperial">
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.product.size"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    <div>{{ selectedProduct.productSizeImperial }}</div>
                    <div>{{ selectedProduct.productSizeMetric }}</div>
                  </dd>
                  <dt>
                    <div v-if="productData.areaPerCarton != null">
                      {{ $resourceString["product.Details.AreaBox.Title"] }}:
                    </div>
                  </dt>
                  <dd v-if="productData.areaPerCarton != null">
                    <div>
                      {{ productData.areaPerCarton.imperial.displayValue }}
                    </div>
                    <div>
                      {{ productData.areaPerCarton.metric.displayValue }}
                    </div>
                  </dd>

                  <dt>
                    <div v-if="
                      productData.gauge != null &&
                      productData.gauge.imperial.formattedValue != '0'
                    ">
                      {{ $resourceString["product.Details.Gauge.Title"] }}:
                    </div>
                  </dt>
                  <dd v-if="
                    productData.gauge != null &&
                    productData.gauge.imperial.formattedValue != '0'
                  ">
                    <div>{{ productData.gauge.imperial.displayValue }}</div>
                    <div>{{ productData.gauge.metric.displayValue }}</div>
                  </dd>
                  <dt>
                    <div v-if="
                      productData.pileThickness != null &&
                      productData.pileThickness.imperial.formattedValue !=
                      '0'
                    ">
                      {{
                        $resourceString["product.Details.FinishedPile.Title"]
                      }}:
                    </div>
                  </dt>
                  <dd v-if="
                    productData.pileThickness != null &&
                    productData.pileThickness.imperial.formattedValue != '0'
                  ">
                    <div>
                      {{ productData.pileThickness.imperial.displayValue }}
                    </div>
                    <div>
                      {{ productData.pileThickness.metric.displayValue }}
                    </div>
                  </dd>
                  <dt>
                    <div v-if="
                      productData.totalThickness != null &&
                      productData.totalThickness.imperial.formattedValue !=
                      '0'
                    ">
                      {{
                        $resourceString["product.Details.TotalThickness.Title"]
                      }}:
                    </div>
                  </dt>
                  <dd v-if="
                    productData.totalThickness != null &&
                    productData.totalThickness.imperial.formattedValue !=
                    '0'
                  ">
                    <div>
                      {{ productData.totalThickness.imperial.displayValue }}
                    </div>
                    <div>
                      {{ productData.totalThickness.metric.displayValue }}
                    </div>
                  </dd>
                  <dt>
                    <div v-if="
                      productData.tuftedWeight != null &&
                      productData.tuftedWeight.imperial.formattedValue !=
                      '0'
                    ">
                      {{ $resourceString["product.Details.TuftedYarn.Title"] }}:
                    </div>
                  </dt>
                  <dd v-if="
                    productData.tuftedWeight != null &&
                    productData.tuftedWeight.imperial.formattedValue != '0'
                  ">
                    <div>
                      {{ productData.tuftedWeight.imperial.displayValue }}
                    </div>
                    <div>
                      {{ productData.tuftedWeight.metric.displayValue }}
                    </div>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
          <div class="wf-product-specification-group">
            <div class="wf-product-specification-subgroup" v-if="productData.recyclability">
              <h3 class="label mb-2 font-weight-bold">
                {{ $resourceString["product.Details.Backing.Title"] }}
              </h3>
              <dl class="description text-uppercase">
                <div>
                  <div v-if="productData.primaryBacking">
                    <dt>
                      <div>
                        {{
                          $resourceString[
                          "product.details.specifications.primary.backing"
                          ]
                        }}
                      </div>
                    </dt>
                    <dd>
                      {{ productData.primaryBacking }}
                    </dd>
                  </div>
                  <div v-if="productData.secondaryBacking">
                    <dt>
                      <div>
                        {{
                          $resourceString[
                          "product.details.specifications.secondary.backing"
                          ]
                        }}
                      </div>
                    </dt>
                    <dd>
                      {{ productData.secondaryBacking }}
                    </dd>
                  </div>
                </div>
              </dl>
            </div>
            <div class="wf-product-specification-subgroup" v-if="productData.testResults.radiantPanel">
              <h3 class="label mb-2 font-weight-bold">
                {{
                  $resourceString[
                  "product.details.specifications.performance.testing"
                  ]
                }}
              </h3>
              <dl class="description text-uppercase">
                <div>
                  <dt>
                    <div>
                      {{
                        $resourceString[
                        "product.details.specifications.radiant.panel"
                        ]
                      }}
                    </div>
                  </dt>
                  <dd>
                    {{ productData.testResults.radiantPanel }}
                  </dd>
                </div>
              </dl>
            </div>
            <div class="wf-product-specification-subgroup" v-if="
              productData.warrantyLinks.length &&
              productData.warrantyLinks[0].link
            ">
              <h3 class="label mb-2 font-weight-bold">
                {{ $resourceString["product.details.specifications.warranty"] }}
              </h3>
              <dl class="description text-uppercase">
                <div v-if="productData.warrantyLinks.length">
                  <div v-for="(warrantyLink, index) in productData.warrantyLinks" :key="index">
                    <a :href="warrantyLink.link">{{ warrantyLink.name }}</a>
                  </div>
                </div>
              </dl>
            </div>
            <div v-if="selectedColor.customPdqAvailable">
              <h3 class="label mb-2 font-weight-bold">
                {{ $resourceString["product.details.specifications.pdq.details"] }}
              </h3>
              <div class="description text-uppercase" v-html="pdqdetails"></div>
            </div>
            <div class="wf-product-specification-subgroup" v-if="
              selectedColor.colorVariationLevel &&
              selectedColor.colorVariationLevel.code &&
              productData.inventoryType == 'resilient'
            ">
              <dl class="description text-uppercase">
                <div>
                  <pc-product-color-variation :specification="true"></pc-product-color-variation>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div class="col-md-12 col-sm-12 col-lg-8 p-0">
      <pc-product-accordion title="Sustainability" sectionId="#sustainabilityPDP" />

      <div class="pt-3 collapse" id="sustainabilityPDP">
        <div class="wf-product-specification-groups">
          <!-- Sustainability -->
          <div class="wf-product-specification-group">
            <div class="wf-product-specification-subgroup">
              <!-- <h3 class="label mb-2">SUSTAINABILITY</h3> -->
              <dl class="description text-uppercase">
                <dt v-if="productData.recyclability != null">
                  <div>
                    {{
                      $resourceString[
                      "product.details.specifications.recyclability"
                      ]
                    }}
                  </div>
                </dt>
                <dd v-if="productData.recyclability != null">
                  {{ productData.recyclability }}
                </dd>
                <dt v-if="
                  productData.recycledContent != null &&
                  productData.recycledContent.postConsumer != null &&
                  productData.recycledContent.postIndustrial != null &&
                  productData.recycledContent.total != null
                ">
                  <div>
                    {{ $resourceString["product.Details.TotalRecyled.Title"] }}:
                  </div>
                </dt>
                <dd v-if="
                  productData.recycledContent != null &&
                  productData.recycledContent.postConsumer != null &&
                  productData.recycledContent.postIndustrial != null &&
                  productData.recycledContent.total != null
                ">
                  {{ $resourceString["product.Details.PostConsumer.Label"] }}:
                  {{ productData.recycledContent.postConsumer }} <br />
                  {{ $resourceString["product.Details.PostIndustrial.Label"] }}:
                  {{ productData.recycledContent.postIndustrial }} <br />
                  {{ $resourceString["product.Details.Total.Label"] }}:
                  {{ productData.recycledContent.total }}
                </dd>
                <dt>
                  <div v-if="productData.carbonData.embodiedCarbon != null">
                    {{
                      $resourceString["product.Details.EmbodiedCarbon.Title"]
                    }}:
                  </div>
                </dt>
                <dd v-if="productData.carbonData.embodiedCarbon != null">
                  <div>
                    {{ productData.carbonData.embodiedCarbon.displayValue }}
                  </div>
                </dd>
                <dt>
                  <div v-if="productData.countryOfOrigin != null">
                    {{
                      $resourceString["product.Details.CountryOfOrigin.Title"]
                    }}:
                  </div>
                </dt>
                <dd v-if="productData.countryOfOrigin != null">
                  {{ productData.countryOfOrigin }}
                </dd>
              </dl>
            </div>
          </div>
          <!-- Third Party Certificates -->
          <div class="wf-product-specification-group">
            <div class="wf-product-specification-subgroup">
              <h3 v-if="
                productData.attributes.length !== 0 ||
                productData.certifications.length !== 0
              " class="label mb-2 font-weight-bold">
                {{
                  $resourceString[
                  "product.details.specifications.third.party.certificates"
                  ]
                }}
              </h3>
              <div>
                <dl class="description text-uppercase">
                  <div v-if="productData.attributes.length > 0" v-for="attribute in productData.attributes"
                    :key="attribute.name">
                    <dt>
                      <div v-if="attribute.pdfLink">
                        <a :href="attribute.pdfLink" target="_blank">
                          {{ attribute.name }}
                        </a>
                      </div>
                    </dt>
                    <dd class="pdfLink">
                      <div v-if="attribute.pdfLink">
                        {{ attribute.status }}
                      </div>
                    </dd>
                  </div>
                  <div v-if="productData.certifications.length > 0" v-for="certification in productData.certifications"
                    :key="certification.name">
                    <dt>
                      <div v-if="certification.pdfLink">
                        <a :href="certification.pdfLink" target="_blank">
                          {{ certification.name }}
                        </a>
                      </div>
                    </dt>
                    <dd class="pdfLink">
                      <div v-if="certification.pdfLink">
                        {{ certification.status }}
                      </div>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
          <!-- Icons-->
          <!-- Icons will be conditionally rendered based on a product's existing certificates and will be implemented in a new section on PDP -->
          <!-- <div v-if="certificationIcons && certificationIcons.length > 0">
            <div
              class="wf-product-specification-groups certification-icons-parent"
              v-for="(item, index) in certificationIcons"
              :key="index"
            >
              <img
                :src="item.icon"
                alt="img"
                class="certification-icons"
                ref="tooltipButton"
              />
              <div
                class="third-party-certification-card third-party-certification-card-tooltip shadow-sm"
              >
                <strong>
                  {{ item.title }}
                </strong>
                <p>{{ item.description }}</p>
              </div>
            </div>
          </div> -->
          <!-- Sustainability Report Card -->
          <div class="wf-product-specification-group"></div>
        </div>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PCSpecificationsRating from "./pc-product-color-variation.vue";
import PcProductAccordion from "./pc-product-accordion.vue";
export default {
  props: ["pdqdetails", "collectionRedirect", "certificationIcons"],
  components: {
    "pc-product-color-variation": PCSpecificationsRating,
    "pc-product-accordion": PcProductAccordion
  },
  data() {
    return {
      specification: this.$resourceString[
        "product.details.specifications.specifications"
      ],
      title: null,
      description: null,
      tooltipX: 0,
      tooltipY: 0
    };
  },
  computed: {
    ...mapGetters({
      selectedColor: "productDetail/color",
      selectedProduct: "productDetail/selectedProduct",
      productData: "productDetail/productData",
      getCompareProducts: "productDetail/getCompareProducts"
    })
  }
};
</script>
